import type * as pf from '@amirada/lib-shared'
import { PfCmdType } from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { ut_capStore, ut_createParamDataString } from '@base/utils/utils'
import { usePfinderAPI } from '@base/composables/pfinderAPI'
import { def_listLimit } from '@base/utils/constants'

export const useListStore = defineStore('listStore', () => {
  const state: { [key: string]: pf.ListNode } = reactive({})
  const pfinderAPI = usePfinderAPI()

  function cacheKey(paramData: tp.IParamData): string {
    // psn narrows the server-side result set → part of the key, same reasoning as in maskStore.
    return [ut_createParamDataString(paramData),
      paramData.namePath,
      paramData.queryUrlServer.psx,
      (paramData.queryUrlServer.psn || []).join(','),
      paramData.queryUrlServer.sort,
      paramData.page].join('#')
  }
  async function callListData(paramData: tp.IParamData, cursor: number = 0, limit: number = def_listLimit): Promise<pf.ListNode | undefined> {
    const listData = getListData(paramData)
    const loadMore: boolean = (listData?.meta?.slice?.cursor || 0) < cursor
    if (!listData || loadMore) {
      const args: pf.PfCmd<PfCmdType.LIST>['arg'] = {
        conf: paramData.namePath.split('/').splice(-1)[0] || '',
        cursor,
        limit,
      }
      const data: tp.IFetchData = {
        paramData,
      }
      const res = await pfinderAPI.fetchData(PfCmdType.LIST, args, data)

      if (res && res.result) {
        setListData(paramData, loadMore, res.result)
      }
      return getListData(paramData)
    }
    else {
      return listData
    }
  }

  function setListData(paramData: tp.IParamData, loadMore: boolean, data: pf.ListNode): void {
    let listData: pf.ListNode | undefined
    // Add to existing data
    if (loadMore) {
      listData = getListData(paramData)
      if (listData) {
        listData.nodes = listData.nodes.concat(data.nodes)
        if (listData.meta && data.meta && data.meta.slice) {
          listData.meta.slice = data.meta.slice
        }
      }
      else {
        listData = data
      }
      // New list data
    }
    else {
      listData = data
    }
    ut_capStore(state)
    state[cacheKey(paramData)] = listData
  }

  function getListData(paramData: tp.IParamData): pf.ListNode | undefined {
    return state[cacheKey(paramData)]
  }

  return {
    state,
    callListData,
    getListData,
    setListData,
  }
})
